<template>
    <div>
        <div class="row g-0" v-if="Object.keys(equip_point_info).length > 0">
            <div class="col-lg-3 col-12" style="display: flex;flex-direction: column;" >
                <button v-for="(sensor_data, sensor_ID) in equip_point_info" v-bind:key="sensor_ID" class="point_btn d-flex justify-content-center" @click="equip_point_type = sensor_ID" :class="{active: equip_point_type == sensor_ID}" >
                    <md-icon class="m-0 fs-8 text-success" v-if="sensor_data['state'] == 0">circle</md-icon>
                    <md-icon class="m-0 fs-8 text-danger" v-if="sensor_data['state'] == 1">circle</md-icon>
                    <md-icon class="m-0 fs-8 text-warning" v-if="sensor_data['state'] == 2">circle</md-icon>
                    <md-icon class="m-0 fs-8 text-secondary" v-if="sensor_data['state'] == 3">circle</md-icon>
                    {{sensor_data["name"]}}：{{sensor_data["value"]}}<label class="ms-2">{{sensor_data["unit"]}}</label>
                </button>
                <div class="point_btn_remain"></div>
            </div>
            <plot-zone v-if="equip_point_type !== null" v-bind:ID="equip_point_type" v-bind:datatype="'value'" v-bind:collection="'sensor'" v-bind:key="equip_point_type"
            v-bind:type="equip_point_info[equip_point_type]['type']"></plot-zone>
        </div>
        <div class="row g-0" v-else>
            <div class="text-center p-2">
                <label class="fs-4">無環境感測器</label>
            </div>
        </div>
    </div>
    
</template>

<script>
import PlotZone from "./PlotZone.vue"

export default {
    name: "sensor_select_zone", 
    props: ["pv_plant_ID"],
    components:{
        PlotZone
    },
    data(){
        return{
            plant_ID: this.$props.pv_plant_ID,
            equip_point_type: null,
            equip_point_info: {}
        }
    },
    methods:{
        pv_sensor_data(){
            const that = this
            this.axios.get(`/pv_sensor_data?pv_plant_ID=${this.plant_ID}`)
            .then(function (data) {
                // 帶入params
                that.equip_point_info = data.data.data
                if(that.equip_point_type === null){
                    for(var i in that.equip_point_info){
                        that.equip_point_type = i
                        break
                    }
                }
            })
        },
    },
    mounted(){
        this.syncdata = setInterval(this.pv_sensor_data, 5000)
        this.pv_sensor_data()
    },
    destroyed(){
        clearInterval(this.syncdata)
    }
}
</script>
<style src="../../assets/css/PlantInfo.css"></style>